import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'react-bootstrap';
import './Authbuttons.css';

function LogoutButton() {
  const { logout } = useAuth0();

  return (
    <Button
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      className="auth-btn logout-btn"
    >
      Log Out
    </Button>
  );
}

export default LogoutButton;